export default __webpack_public_path__ + "static/media/480_dummy2016-eventagentur01-de-mobile.ae4bc551.png";